export const stepsInventoryControl = {
	config: {
		labels: {
			titleInventory: "Dé un título al inventario",
			exampleTitleInventory: "ej: 'Inventario de bebidas'",
			stockistName: "Nombre del almacenista",
			selectStock: "Seleccione el inventario para crear el inventario",
			selectCategory: "Seleccione las categorías",
		},
		inventoryPlaceholder: "Ingrese el título del inventario",
		stockPlaceholder: "Haga clic para seleccionar",
		categoryPlaceholder: "Haga clic para seleccionar las categorías",
	},
	count: {
		labels: {
			count: "Conteo",
			unit: "Unidad",
			price: "Precio de costo",
			amount: "Valor total",
			deleteCategory: "Eliminar categoría",
			deleteSelectedProducts: "Eliminar seleccionados",
			inventoryItems: "Elementos del inventario",
			deleteItems: "Eliminar elementos",
			modalDescription:
				"Al confirmar la acción eliminará permanentemente {{amount}} {{itemLabel}} del inventario. ¿Desea continuar?",
			modalDeleteCategoryMessage:
				"Al confirmar la acción la categoría {{category}} será eliminada permanentemente. ¿Desea continuar?",
			modalDeleteProductMessage:
				"Al confirmar la acción el producto {{product}} será eliminado permanentemente. ¿Desea continuar?",
			deleteSelectedItems: "Eliminar elementos seleccionados",
			searchProduct: "Buscar producto",
			item: {
				single: "elemento",
				plural: "elementos",
			},
		},
		invalidCountConverted:
			"El conteo en este campo no debe exceder, o ser igual, a la medida máxima de la conversión registrada.",
		filter: {
			byProduct: "Organizar por producto",
			byCategory: "Organizar por categoría",
		},
		notification: {
			success: "Elementos eliminados con éxito.",
			error:
				"Ocurrió un error en la eliminación de los elementos. Intente nuevamente más tarde.",
		},
	},
	resume: {
		tableColumns: {
			category: "Categoría",
			quantity: "Cantidad",
			difference: "Diferencia",
			system: "Sistema",
			product: "Producto",
			systemQuantity: "Cant del sistema",
			count: "Conteo",
			countDifference: "Diferencia en cant",
			monetaryDifference: "Diferencia en {{currencyNarrowSymbol}}",
			unit: "Unidad",
			action: {
				label: "Acción",
				loss: "Pérdida",
				adjust: "Ajuste",
			},
		},
	},
	adjustLoss: {
		tableColumns: {
			category: "Categoría",
			quantity: "Cantidad",
			difference: "Diferencia",
			system: "Sistema",
			product: "Producto",
			systemQuantity: "Cant del sistema",
			count: "Conteo",
			countDifference: "Diferencia en cant",
			monetaryDifference: "Diferencia en {{currencyNarrowSymbol}}",
			unit: "Unidad",
			action: {
				label: "Acción",
				loss: "Pérdida",
				adjust: "Ajuste",
			},
		},
	},
	approval: {
		exportExcel: "Descargar en Excel",
		inconsistencyInventory: {
			products: "Productos",
			sumOfPositiveDifferences: "Suma de diferencias positivas",
			sumOfNegativeDifferences: "Suma de diferencias negativas",
			inconsistenciesByQuantity: "5 principales inconsistencias por cantidad",
			inconsistenciesByDiffences: "5 principales inconsistencias por valor",
			checkedProducts: "Productos verificados",
		},
		inputPlaceholder: "Buscar producto",
		select: {
			all: "Mostrar todos los elementos",
			onlyNegativeDifference: "Solo productos con diferencia negativa",
			onlyPositiveDifference: "Solo productos con diferencia positiva",
			onlyWithoutDifference: "Solo productos sin diferencia",
		},
		tableColumns: {
			category: "Categoría",
			quantity: "Cantidad",
			difference: "Diferencia",
			system: "Sistema",
			product: "Producto",
			systemQuantity: "Cantidad del sistema",
			count: "Conteo",
			countDifference: "Diferencia en cant",
			monetaryDifference: "Diferencia en {{currencyNarrowSymbol}}",
			unit: "Unidad",
			action: {
				label: "Acción",
				loss: "Pérdida",
				adjust: "Ajuste",
			},
		},
		searchProduct: "Buscar producto",
	},
};
